import React, { forwardRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocale } from "routes/LayoutContext";
import { getLocaleUrl } from "utils";
import { getParams } from "../../utils/utils";
import http from "utils/http";
import Modal from "components/Modal";
import options from "utils/options";
import { useIntl } from "react-intl";
import {
  setAccountIdValue,
  setCountryOptions,
  setIpData,
} from "Reducer/appReducer";

import { ModalList } from "components/LayoutStyles/LayoutStyles";
import classNames from "classnames";

const LanguageModal = forwardRef((props, ref) => {
  const locale = useLocale();
  const history = useHistory();
  const dispatch = useDispatch();
  const { formatMessage: f } = useIntl();

  const [showModal, setModalVisible] = useState(false);
  const [selectedLocale, setSelectedLocale] = useState(locale);

  React.useImperativeHandle(ref, () => ({
    open: openModal,
  }));

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  };

  const changeLocale = (value) => {
    setSelectedLocale(value);
    closeModal();
  };

  useEffect(() => {
    let _languageId;
    switch (locale) {
      case "en":
        _languageId = 1;
        break;
      case "tc":
        _languageId = 2;
        break;
      case "jp":
        _languageId = 4;
        break;
      case "cn":
      default:
        _languageId = 3;
        break;
    }

    http
      .GET("api/PublicSetting/Country", {
        languageId: _languageId,
      })
      .then((apiResult) => {
        if (apiResult && apiResult.data.success) {
          dispatch(setCountryOptions(apiResult.data.content));
        }
      });

    http.GET("//jsonip.com/", {}).then((response) => {
      //{"ip":"123.51.133.80","geo-ip":"https://getjsonip.com/#plus","API Help":"https://getjsonip.com/#docs"}
      let ip = response && response.status == 200 ? response.data.ip : "";
      http
        .GET("api/IPInfo/Get", {
          IP: ip,
        })
        .then((apiResult) => {
          // console.log(apiResult);
          if (apiResult && apiResult.data?.success) {
            dispatch(setIpData(apiResult.data.content));
          }
        });
    });
    // eslint-disable-next-line
  }, [locale]);

  return (
    <Modal
      visible={showModal}
      keyboard={true}
      onCancel={closeModal}
      onOk={() => {
        console.log("111");
      }}
      name={"Language"}
      afterClose={() => {
        history.push(getLocaleUrl(selectedLocale));
      }}
      width={760}
      footer={false}
    >
      {options.LanguageList.map((language) => (
        <ModalList
          key={language.value}
          className={classNames({ active: language.value === selectedLocale })}
          onClick={() => changeLocale(language.value)}
        >
          <span>{language.label}</span>
        </ModalList>
      ))}
    </Modal>
  );
});

export { LanguageModal };
